import React, { useEffect, useState } from 'react';

import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { selectbookingdetails, bookingdetails, selectDetailsLoading } from "./HotelSlice";
import BookingReviewShimmer from './BookingReviewShimmer';
const Cancellation = () => {
    const [cancellationReason, setCancellationReason] = useState('');
    const [selectedGuests, setSelectedGuests] = useState([]);
    const [BookingId, setBookingId] = useState([]);
    const location = useLocation();
    const dispatch = useDispatch();
    const selectbookingdetailsData = useSelector(selectbookingdetails)
    const DetailsLoading = useSelector(selectDetailsLoading)
    const HotelDetails = selectbookingdetailsData && selectbookingdetailsData.status && selectbookingdetailsData.HotelDetails
    const RoomInfos = selectbookingdetailsData && selectbookingdetailsData.status && selectbookingdetailsData.RoomInfo
    const WalletBalance = selectbookingdetailsData && selectbookingdetailsData.status && selectbookingdetailsData.WalletBalance
    const fares = selectbookingdetailsData && selectbookingdetailsData.status && selectbookingdetailsData.fare
    const travellers = selectbookingdetailsData && selectbookingdetailsData.status && selectbookingdetailsData.travellers
    const CurrencySymbol = selectbookingdetailsData && selectbookingdetailsData.status && selectbookingdetailsData.HotelDetails.currency || "INR"
    const BookingStatus = selectbookingdetailsData && selectbookingdetailsData.status && selectbookingdetailsData.HotelDetails?.BookingStatus || 0
    const safeMemberDetails = Array.isArray(travellers) ? travellers : [];

    useEffect(() => {
        const parts = location.pathname.split("/").filter(Boolean);
        const bookingId = parts[parts.length - 1];
        setBookingId(bookingId)
        if (DetailsLoading && BookingStatus === 0) {
            setTimeout(() => {
                FetchBookingDetails({
                    FormData: {
                        BookingID: bookingId,
                    }
                });
            }, 1000);
        }

    }, [location.pathname, BookingStatus]);

    const FetchBookingDetails = async (payload) => {
        try { await dispatch(bookingdetails(payload)).unwrap(); }
        catch (err) { console.error("Fetch failed:", err); }
    };

    const handleGuestSelection = (roomNumber) => {
        setSelectedGuests(prev =>
            prev.includes(roomNumber)
                ? prev.filter(room => room !== roomNumber)
                : [...prev, roomNumber]
        );
    };
    const calculatePaxCounts = (data) => {
        if (!data || !Array.isArray(data)) {
            return { adults: 0, children: 0, infants: 0 };
        }

        const counts = data.reduce((acc, roomGroup) => {
            if (roomGroup.Rooms && Array.isArray(roomGroup.Rooms)) {
                roomGroup.Rooms.forEach(room => {
                    acc.adults += room.Adult || 0;
                    acc.children += room.Child || 0;
                    acc.infants += room.Infant || 0;
                });
            }
            return acc;
        }, { adults: 0, children: 0, infants: 0 });

        return counts;
    };

    const paxCounts = calculatePaxCounts(
        selectbookingdetailsData?.data?.RoomInfo ||
        selectbookingdetailsData?.payload?.RoomInfo ||
        selectbookingdetailsData?.RoomInfo ||
        selectbookingdetailsData?.result?.RoomInfo
    );
    return (
        <>
            {DetailsLoading ? (
                <>
                    <div className="p-4">
                        <BookingReviewShimmer />
                    </div>
                </>
            ) :
                (<div className="min-h-screen bg-gray-100 p-4 space-y-4 font-sans">

                    <div className="bg-white rounded shadow border border-gray-300 p-4">
                        <h1 className="text-xl text-center uppercase text-gray-800 mb-3">
                            {HotelDetails?.name}
                        </h1>
                        <div className="flex justify-between">
                            <div>
                                <div className="text-gray-600">Check in</div>
                                <div className="text-gray-800">{HotelDetails?.checkinDate} 12:00 AM</div>
                            </div>
                            <div className="text-right">
                                <div className="text-gray-600">Check out</div>
                                <div className="text-gray-800">{HotelDetails?.checkoutDate} 12:00 AM</div>
                            </div>
                        </div>
                    </div>

                    {/* Card 2: Member Details with Checkboxes */}

                    <div className="bg-white rounded shadow border border-gray-300 p-4">
                        <div className="text-center mb-3">
                            <div className="text-gray-600">RoomInfo</div>
                            <div className="text-gray-800">{fares.roomCoun} Room(s) {paxCounts.adults} Adult(s) {paxCounts.children} Child(s)</div>
                        </div>

                        <div className="space-y-4">
                            {RoomInfos && RoomInfos[0]?.Rooms.map((room, index) => (
                                <div key={index} className="border border-gray-200 rounded-lg">

                                    <div className="grid grid-cols-4 items-center gap-4 p-3 border-b border-gray-200">
                                        <div className="flex items-center gap-3">
                                            <input
                                                type="checkbox"
                                                checked={selectedGuests.includes(index)}
                                                onChange={() => handleGuestSelection(index)}
                                                className="w-4 h-4 text-blue-600 border-gray-300 rounded"
                                            />

                                            <div className="text-gray-800 font-medium">{room.RoomCategory}</div>
                                        </div>
                                        <div className="text-gray-600">{room.MealBase}</div>
                                        <div className="text-gray-600">{room.Adult} Adult(s)</div>
                                    </div>

                                    <div className="p-3 bg-gray-50">
                                        <div className="text-gray-800 font-medium mb-2">Guests:</div>
                                        <div className="space-y-2">
                                            <div className="text-gray-700 ml-4">{room.guestName}</div>


                                            <div className="flex flex-wrap gap-2">
                                                {travellers && travellers[index] && travellers[index].map((member, memberIndex) => (
                                                    <div key={memberIndex} className="border border-gray-300 rounded-md p-2 max-w-[350px]">
                                                        <span className="text-gray-700 font-bold text-sm truncate block">
                                                            {member.title} {member.fname} {member.lname}
                                                        </span>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                    <div className="bg-white rounded shadow border border-gray-300 p-4">
                        <div className="text-gray-800 mb-2">Cancellation Reasons :</div>
                        <select
                            value={cancellationReason}
                            onChange={(e) => setCancellationReason(e.target.value)}
                            className="w-full p-2 border border-gray-400 rounded text-gray-700"
                        >
                            <option value="">Select a Cancellation Reason</option>
                            <option value="change_plans">Change of plans</option>
                            <option value="better_price">Found better price</option>
                            <option value="other">Other reason</option>
                        </select>
                    </div>


                    <div className="bg-white rounded shadow border border-gray-300 p-4">
                        <button className="w-full bg-red-600 text-white py-3 rounded font-medium hover:bg-red-700">
                            Proceed with Cancellation
                        </button>
                    </div>

                </div>
                )}
        </>
    );
};

export default Cancellation;